import {Injectable, Injector} from '@angular/core';
import {EntityCollectionServiceElementsFactory} from '@ngrx/data';
import {AbstractRepositoryV2} from 'src/app/modules/core/service/v2/abstractRepositoryV2';
import {SaleModel} from '../../../api/entity/sale.model';



@Injectable({providedIn: 'root'})
export class SaleRepository extends AbstractRepositoryV2<SaleModel>{
    constructor(serviceElementsFactory: EntityCollectionServiceElementsFactory, injector: Injector) {
        super('Sale', serviceElementsFactory, injector);
    }
}
